import { render } from "./pegawai-list-odata-lookup.vue?vue&type=template&id=2392a06d"
import script from "./pegawai-list-odata-lookup.vue?vue&type=script&lang=js"
export * from "./pegawai-list-odata-lookup.vue?vue&type=script&lang=js"

import "./pegawai-list-odata-lookup.vue?vue&type=style&index=0&id=2392a06d&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__